import { css, SerializedStyles } from "@emotion/react";

type Size = "XSS" | "XS" | "S" | "SM" | "M" | "L" | "XL";
type Justify = "flexstart" | "flexend" | "center" | "spacearound" | "spacebetween" | "spaceevenly";
export const sizes: Record<Size, string> = {
	XSS: "0.25rem",
	XS: "0.5rem",
	S: "0.625rem",
	SM: "1rem",
	M: "1.25rem",
	L: "1.875rem",
	XL: "2.5rem",
};

export const stack = (
	gap: number | Size | undefined = undefined,
	justify: Justify = "flexstart",
	align: "flexstart" | "flexend" | "center" | "stretch" = "flexstart",
	reverse?: "reverse",
): SerializedStyles => css`
	display: flex;
	flex-direction: ${reverse ? "column-reverse" : "column"};
	justify-content: ${cssText[justify]};
	align-items: ${cssText[align]};

	${gap !== undefined &&
	css`
		gap: ${typeof gap === "number" ? `${gap / 16}rem` : sizes[gap]};
	`}
`;

export const row = (
	gap: number | Size | undefined = undefined,
	justify: Justify = "flexstart",
	align: "flexstart" | "flexend" | "center" | "stretch" | "baseline" = "flexstart",
	reverse?: "reverse",
): SerializedStyles => css`
	display: flex;
	flex-direction: ${reverse ? "row-reverse" : "row"};
	justify-content: ${cssText[justify]};
	align-items: ${cssText[align]};

	${gap !== undefined &&
	css`
		gap: ${typeof gap === "number" ? `${gap / 16}rem` : sizes[gap]};
	`}
`;

export const absoluteFillObject = css`
	position: absolute;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
`;

const cssText: Record<
	"flexstart" | "flexend" | "center" | "spacearound" | "spacebetween" | "spaceevenly" | "stretch" | "baseline",
	string
> = {
	["flexstart"]: "flex-start",
	["flexend"]: "flex-end",
	["center"]: "center",
	["spacearound"]: "space-around",
	["spacebetween"]: "space-between",
	["spaceevenly"]: "space-evenly",
	["stretch"]: "stretch",
	["baseline"]: "baseline",
};
